var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._b({ref:"editor",staticClass:"viewer__image-editor top-left fill-block",class:{ loading: !_vm.imageEditor }},'div',_vm.themeDataAttr,false))
}
var staticRenderFns = []

export { render, staticRenderFns }